import type { DataCallMetrics, SLOReportEntry, SLOKey } from "./types";
import { SLO_DEFINITIONS } from "./slo-definitions";
import {
  calculateErrorRate,
  calculatePercentiles,
  filterMetricsForSLO,
} from "./slo-helpers";

export type SLOReport = Record<SLOKey, SLOReportEntry>;

export function buildSloReport(
  getMetrics: (window: number) => DataCallMetrics[],
): SLOReport {
  const report = {} as SLOReport;

  (
    Object.entries(SLO_DEFINITIONS) as [
      SLOKey,
      (typeof SLO_DEFINITIONS)[SLOKey],
    ][]
  ).forEach(([key, slo]) => {
    let metrics = getMetrics(slo.window);
    metrics = filterMetricsForSLO(metrics, key);

    if (metrics.length < 10) {
      report[key] = {
        compliant: true,
        violations: [],
        metrics: {
          p50: 0,
          p95: 0,
          p99: 0,
          errorRate: 0,
          sampleSize: metrics.length,
        },
      };
      return;
    }

    const percentiles = calculatePercentiles(metrics);
    const errorRate = calculateErrorRate(metrics);
    const violations: string[] = [];

    if (percentiles.p95 > slo.targets.p95) {
      violations.push(`p95: ${percentiles.p95}ms > ${slo.targets.p95}ms`);
    }
    if (percentiles.p99 > slo.targets.p99) {
      violations.push(`p99: ${percentiles.p99}ms > ${slo.targets.p99}ms`);
    }
    if (errorRate > slo.targets.errorRate) {
      violations.push(
        `errorRate: ${(errorRate * 100).toFixed(2)}% > ${(slo.targets.errorRate * 100).toFixed(2)}%`,
      );
    }

    report[key] = {
      compliant: violations.length === 0,
      violations,
      metrics: {
        ...percentiles,
        errorRate,
        sampleSize: metrics.length,
      },
    };
  });

  return report;
}
